import React from 'react';
import Modal from 'components/shared/Modal/Modal';
import { BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import './HeatmapImageCollectingScreen.css';
import LoadingIndicator from 'components/shared/LoadingIndicator/LoadingIndicator';

const HeatmapImageCollectingScreen = (props) => {
  const onCloseScreen = () => {
    props.onClose();
  };

  return (
    <Modal
      className={'HeatmapImageCollectingScreen_Modal'}
      animateX={false}
      close={onCloseScreen}
      noPadding
      noMinWidth
      hideCloseButton={true}
      width={229}
      height={166}
    >
      <div className="HeatmapImageCollectingScreen_Container" id="HeatmapImageCollectingScreen_Container">
        <div
          className="HeatmapImageCollectingScreen_Container_Message"
          id="HeatmapImageCollectingScreen_Container_Message"
        >
          <LoadingIndicator text={'Collecting files(s)'}/>
        </div>
        {BUTTON_LOADING_CIRCLE}
      </div>
    </Modal>
  );
};

export default React.memo(HeatmapImageCollectingScreen);
